// extracted by mini-css-extract-plugin
module.exports = {"root":"BestArtist_root__YPJfB","content":"BestArtist_content__FtTmP","text":"BestArtist_text__1SZ6R","desc":"BestArtist_desc__3Cu0C","title":"BestArtist_title__1Dg0T"};